import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import React, { useCallback, useEffect, useState } from 'react';
import Text from '@components/Text';
import { themeDefault } from 'src/theme-revamp';
import Stepper from '@components/_Revamp/Stepper';
import ReviewMessageBox from './components/ReviewMessageBox';
import Accordion from '@components/_Revamp/Accordion';
import Listing from '@components/_Revamp/Listing';
import Button from '@components/_Revamp/Button';
import { useAvivaSelector } from '@redux/hook';
import { useHistory } from 'react-router-dom';
import { MyInfoForm } from '@models/MLTC_R3/MyInfo.model';
import { HealthDeclarationForm } from '@models/MLTC_R3/HealthDeclaration.model';
import { isEmpty } from 'lodash';
import { Helpers } from '@utils/helpers';
import { SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model';
import Modal from '@components/_Revamp/Modal';
import EditModal from './components/EditModal';
import { GAAviva, MLTC_R3_JOURNEY_NAME } from '@utils/gaAvivaR3';
import { Step } from '@components/_Revamp/Stepper/Stepper';
import BottomSheet from '@components/_Revamp/BottomSheet';

export interface ReviewProps { }
interface IItem { text: string, value: string };

export interface EditBtnProps {
  onClick?: (e: any) => void;
}


const Review = () => {
  //TODO : Get previous data from step 1 to 4;


  const history = useHistory();
  const basicDetails = useAvivaSelector(state => state.mltcR3Step1.basicDetails);
  const myInfoForm = useAvivaSelector(state => state.mltcR3Step4.myInfoForm);
  const isMyInfoCompleted = useAvivaSelector(state=>state.mltcR3Step4.isMyInfoStepCompleted)
  const isDeclarationCompleted = useAvivaSelector(state=>state.mltcR3Step4.completedDeclarationStep)
  const healthValues = useAvivaSelector((state) => state.mltcR3Step3.healthDeclaration);
  const myInfoAddressForm = useAvivaSelector(state => state.mltcR3Step4.myInfoAddressForm);
  const quoteRawResponse = useAvivaSelector(state => state.mltcR3Step2.quoteRawResponse);
  const gioDeclaration = useAvivaSelector(state => state.mltcR3Step2.gioDeclaration);
  const qrClientDetails = useAvivaSelector(
    (state) => state.mltcR3Step5.qrClientDetails,
  );
  const validQRClient = qrClientDetails?.status === "SUCCESS";

  const [personalDetails, setPersonalDetails] = useState<IItem[]>([]);
  const [otherDetails, setOtherDetails] = useState<IItem[]>([]);
  const [healthQuestions, setHealthQuestions] = useState<IItem[]>([]);
  const [planDetails, setPlanDetails] = useState<IItem[]>([]);

  const [editModalVisible, setEditModalVisible] = useState<boolean>(false);
  const [editModalData, setEditModalData] = useState<any>(null);


  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);
  const qrLTCDiscountDescription = useAvivaSelector(state => state.mltcR3Step5.qrLTCDiscountDescription);
  const age = basicDetails?.dob
    ? Helpers.getAge(
        new Date(
          `${basicDetails.dob.month}/${basicDetails.dob.day}/${basicDetails.dob.year}`,
        ),
      )
    : null;  
  const isEBLTC = campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED" && age !== null && (age >= 31 && age <= 40);
  const paramCC = campaignDetail?.campaignCode ? `?cc=${campaignDetail.campaignCode}` : '';
  const analyticUrlParams = useAvivaSelector(state => state.urlAnalytic.param);
  const analyticParam = Helpers.getUrlAnalyticParams(paramCC !== "", analyticUrlParams);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [aaTracking,setAATracking] = useState<string[]>([]);

  const trackOnLoad = useCallback((formName: string): void => {
    if(!aaTracking.includes(formName)){
      setAATracking([...aaTracking,formName]);
      const GA = GAAviva.getInstance();
      let { form, page } = GA.digitalData;
      form.name = formName;

      // QB-AA-Tracking fix: step 15 ("Review Summary") of the journey.
      page.journeyName = MLTC_R3_JOURNEY_NAME;
      page.stepName = "Review Summary";
      page.stepNumber = "15";

      GA.trackPageLoad({ form, page });
    }
  },[aaTracking]);

  const EditComponent = ({ onClick }: EditBtnProps) => {
    return <EditBtnParagraph onClick={onClick}>Edit</EditBtnParagraph>;
  };

  const displayModal = (e: any, path: string, pageTitle: string) => {

    e.stopPropagation();
    setEditModalVisible(true);
    let obj = {
      title: pageTitle,
      onBackClick: () => {
        setEditModalVisible(false);
      },
      onProceedClick: () => {

        history.push(path + paramCC + analyticParam);
        setEditModalVisible(true);
      }
    }
    setEditModalData(obj);
  };

  useEffect(() => {    
    if (gioDeclaration !== "GIO") {
      if (isEmpty(basicDetails) || isEmpty(myInfoForm)) {
        history.push("/mltc/lets-get-started" + paramCC + analyticParam);
        return;
      }
      if (!myInfoForm.salutation || !myInfoForm.income || !myInfoForm.salutation || !isMyInfoCompleted) {
        history.replace("/mltc/my-info")
        return
      }
    }
    if (!isDeclarationCompleted) {
      history.replace("/mltc/declaration")
      return
    }
    
    if (!isEmpty(basicDetails)) {
      const { month, day, year } = basicDetails?.dob || { month: '', day: '', year: '' };
      const stringDate = `${month}/${day}/${year}`;
      const age = Helpers.getAge(new Date(stringDate));
      if (quoteRawResponse) {
        const planQuotation = new SQSPocketResponse(quoteRawResponse, age);
        setPlanDetails(planQuotation.mltcPlanDetails);
        console.log("plan details", planQuotation.mltcPlanDetails);
      }
    }
    if (myInfoForm) {
      const info = new MyInfoForm(myInfoForm);
      info.extraAddress = myInfoAddressForm;
      setPersonalDetails(info.reviewPersonalDetails);
      setOtherDetails(info.reviewOtherDetails);
      console.log("info", info);
      console.log("info.extraAddress", info.extraAddress);
      console.log("info.reviewOtherDetails", info.reviewOtherDetails);
      console.log("info.reviewPersonalDetails", info.reviewPersonalDetails);
      console.log("isMailingAdressDifferent", info.isMailingAdressDifferent);
    }

    const aboutYouHealth = new HealthDeclarationForm(healthValues);
    setHealthQuestions(aboutYouHealth.reviewHealth);
    console.log("aboutYouHealth.reviewHealth", aboutYouHealth.reviewHealth);
  }, []);


  useEffect(()=>{
    if(!isLoaded)
    {
      setIsLoaded(true);
      trackOnLoad("mltc_review_form");
    }
  }, [isLoaded, trackOnLoad])

  const stepsList: Step[] = [
    {
      label: 'Basic Info',
      isCurrentStep: false,
      path: "/mltc/lets-get-started",
      disabled: validQRClient
    },
    {
      label: 'Quote',
      isCurrentStep: false,
      path: "/mltc/choose-plan"
    },
    {
      label: 'Health Declaration',
      isCurrentStep: false,
      path: "/mltc/health",
      disabled: gioDeclaration === "GIO",
    },
    {
      label: 'Start Application',
      isCurrentStep: false,
      path: "/mltc/my-info"
    },
    {
      label: 'Review & Payment',
      isCurrentStep: true,
      path: "/mltc/review"
    },
  ];

  const EBCampaignDiscount = (
    <React.Fragment>
      {`- ${qrLTCDiscountDescription}`}
      {<br />}
      {`-S$599 Discount`}
    </React.Fragment>
  );

  const planSummarySources = [
    { heading: { text: 'Plan', value: `${planDetails[0]?.value ? planDetails[0]?.value : '-'}` } },
    { heading: { text: 'Monthly benefit selected', value: `${planDetails[1]?.value ? planDetails[1]?.value : '-'}` } },
    { heading: { text: 'Plan Structure', value: `${planDetails[2]?.value ? planDetails[2]?.value : '-'}` } },
    { heading: { text: 'Policy Term', value: `${planDetails[3]?.value ? planDetails[3]?.value : '-'}` } },
    { heading: { text: 'Premium Term', value: `${planDetails[4]?.value ? planDetails[4]?.value : '-'}` } },
    ...(gioDeclaration === 'GIO'
      ? [{ heading: { text: 'Underwriting Campaign', value: 'Eligible' }}]
      : []),
    ...(isEBLTC ? [{ heading: { text: 'Singlife EB Campaign', value: EBCampaignDiscount }}] : []),

  ];
  const personalInformationSources = [
    { heading: { text: 'Full Name(as per NRIC)', value: `${personalDetails[0]?.value ? personalDetails[0]?.value : "-"}` } },
    { heading: { text: 'First Name', value: `${personalDetails[2]?.value ? personalDetails[2]?.value : "-"}` } },
    { heading: { text: 'Family Name', value: `${personalDetails[1]?.value ? personalDetails[1]?.value : "-"}` } },
    { heading: { text: 'NRIC/FIN', value: `${personalDetails[3]?.value ? personalDetails[3]?.value : "-"}` } },
    { heading: { text: 'Gender', value: `${personalDetails[4]?.value ? personalDetails[4]?.value : "-"}` } },
    { heading: { text: 'Nationality', value: `${personalDetails[5]?.value ? personalDetails[5]?.value : "-"}` } },
    { heading: { text: 'Date of Birth', value: `${personalDetails[6]?.value ? personalDetails[6]?.value : "-"}` } },
    { heading: { text: 'Postal Code', value: `${personalDetails[9]?.value ? personalDetails[9]?.value : "-"}` } },
    { heading: { text: 'Unit', value: `${personalDetails[10]?.value ? personalDetails[10]?.value : "-"}` } },
    { heading: { text: 'Street', value: `${personalDetails[11]?.value ? personalDetails[11]?.value : "-"}` } },
    { heading: { text: 'Building Name', value: `${personalDetails[13]?.value ? personalDetails[13]?.value : "-"}` } },
  ];

  const otherDetailsSources = [
    { heading: { text: 'Salutation', value: `${otherDetails[0]?.value ? otherDetails[0]?.value : "-"}` } },
    { heading: { text: 'Mobile Number', value: `${otherDetails[1]?.value ? otherDetails[1]?.value : "-"}` } },
    { heading: { text: 'Email', value: `${otherDetails[2]?.value ? otherDetails[2]?.value : "-"}` } },
    { heading: { text: 'Annual Income', value: `${otherDetails[5]?.value ? otherDetails[5]?.value : "-"}` } },
    { heading: { text: 'Mailing address is different from residential address', value: `${otherDetails[6]?.value ? otherDetails[6]?.value : "-"}` } },
    { heading: { text: 'Postal Code', value: `${otherDetails[7]?.value ? otherDetails[7]?.value : "-"}` } },
    { heading: { text: 'Unit', value: `${otherDetails[8]?.value ? otherDetails[8]?.value : "-"}` } },
    { heading: { text: 'Street', value: `${otherDetails[9]?.value ? otherDetails[9]?.value : "-"}` } },
    { heading: { text: 'Block / Street no.', value: `${otherDetails[10]?.value ? otherDetails[10]?.value : "-"}` } },
    { heading: { text: 'Building name(if any)', value: `${otherDetails[11]?.value ? otherDetails[11]?.value : "-"}` } },
    { heading: { text: 'Update mailing address for all my life and health policies with Singlife', value: `${otherDetails[12]?.value ? otherDetails[12]?.value : "-"}` } },
  ];

  const healthSources = [
    { heading: { text: 'Height', value: `${healthValues?.height ? healthValues?.height : '-'}` } },
    { heading: { text: 'Weight', value: `${healthValues?.weight ? healthValues?.weight : '-'}` } },
    { heading: { text: 'Medical Conditions', value: `${healthQuestions[0]?.value ? healthQuestions[0]?.value : 'Nil'}` } },
    {
      heading: {
        text: 'Any conditions for which you are on medication for more than 14 days, require regular medical treatment or follow up',
        value: `${healthQuestions[1]?.value ? healthQuestions[1]?.value : 'No'}`,
      },
    },
    { heading: { text: 'Recurring symptoms yet to seek medical advice', value: `${healthQuestions[1]?.value ? healthQuestions[1]?.value : 'No'}` } },
    { heading: { text: 'Assistance of another person or mechanical aids to perform your daily activities', value: `${healthQuestions[2]?.value ? healthQuestions[2]?.value : 'No'}` } },
    {
      heading: {
        text: 'Experienced a drop in your ability to carry on with your domestic way of living or social activities in the last 12 months',
        value: `${healthQuestions[3]?.value ? healthQuestions[3]?.value : 'No'}`
      },
    },
  ];

  return (
    <Container>
      <FormContainer maxWidth={"792px"} margin={"150px auto 0"}>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={'170px'}>
            <Text align={'center'} theme={themeDefault} className={HeaderTitleCss}>
              Review Summary
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Please look through to ensure all the information is correct before proceeding to the next step.
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>
      </FormContainer>

      <FormContentContainer>
        <ReviewMessageBox rowGap={'8px'}>
          <Text theme={themeDefault} className={MessageBoxTitleCss}>
            Please Note:
          </Text>
          <Text theme={themeDefault} className={MessageBoxParagraphCss}>
            Pursuant to Section 23(5) of the Insurance Act 1966, you are required to disclose in this application form fully and faithfully all facts which
            you know or ought to know. Otherwise the insurance effected may be void.
          </Text>
        </ReviewMessageBox>
      </FormContentContainer>

      <FormContentContainer>
        <React.Fragment>
          <Accordion isExpanded={true} {...args} extraElement={<EditComponent onClick={(e) => { displayModal(e, '/mltc/choose-plan', "Plan Selection"); }} />} title='Plan Summary'>
            <Listing sources={planSummarySources} variant='alternate' underlineColor='#F5F5F5' margin='' />
          </Accordion>
          <Accordion isExpanded={false} {...args} title='Personal Information'>
            <Listing sources={personalInformationSources} variant='alternate' underlineColor='#F5F5F5' margin='' />
          </Accordion>
          <Accordion isExpanded={false} {...args} extraElement={<EditComponent onClick={(e) => { displayModal(e, '/mltc/my-info', "My Information"); }} />} title='Other Details'>
            <Listing sources={otherDetailsSources} variant='alternate' underlineColor='#F5F5F5' margin='' />
          </Accordion>
          {
            gioDeclaration === "GIO" ? null :
              <Accordion isExpanded={false} {...args} extraElement={<EditComponent onClick={(e) => { displayModal(e, '/mltc/health', "Health Declaration"); }} />} title='Health Questions'>
                <Listing sources={healthSources} variant='alternate' underlineColor='#F5F5F5' margin='' />
              </Accordion>
          }
        </React.Fragment>
      </FormContentContainer>
      
      <FormButtonContainer>
        <Button
          onClick={() => {

            history.push('/mltc/my-info' + paramCC + analyticParam);
          }}
          width={'180px'}
          variant={'secondary'}
          theme={themeDefault}
          label={'Back'}></Button>
        <Button
          onClick={() => {

            history.push('/mltc/prepayment' + paramCC + analyticParam);
          }}
          width={'180px'}
          variant={'default'}
          theme={themeDefault}
          label={'Proceed'}></Button>
      </FormButtonContainer>


      <Stepper steps={stepsList}></Stepper>


      <Modal show={editModalVisible}>
        <EditModal data={editModalData}></EditModal>
      </Modal>
      <BottomSheet />

    </Container>
  );
};

export default Review;

//Added padding for this because the max-width is 792, so stepper will overlap
const Container = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1230px;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  @media screen and (min-width: 768px) {
    padding: 0 24px;
  }
  @media screen and (min-width: 1024px) {
    padding: 0 200px;
  }
`;




const EditBtnParagraph = styled.p`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #883e89;
`;
const HeaderTitleCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const MessageBoxTitleCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  color: #434343;
`;
const MessageBoxParagraphCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  line-height: 180%;
  color: #444444;
  font-size: 14px;
  font-weight: 500;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const FormContainer = styled.div<FormContainerProps>`
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 327px;
  width: 100%;
  transition: all 0.2s ease;
  margin: 200px auto 0 auto;
  @media screen and (min-width: 768px) {
    max-width: 588px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }

  @media screen and (min-width: 1250px) {
    margin: ${(props) => (props.margin ? props.margin : '150px auto 0 auto')};
  }

`;
const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 24px;
  @media screen and (min-width: 768px) {
    margin-bottom: 48px;
  }
`;
const FormContentContainer = styled.div`
  display: block;
  flex-wrap: wrap;
  column-gap: 30px;
  flex-direction: column;
  justify-content: space-evenly;
  margin: auto;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    max-width: 588px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`;
const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px 16px 20px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 80px;
  margin-bottom: 100px;
  column-gap: 40px;
  width: 100%; 
  padding: 0 24px;
  @media screen and (max-width: 768px) {
    column-gap: 0;
    row-gap: 10px;
    margin-top: 40px;
    flex-direction: column;
    align-items: center;
  }
`;


const HeaderDescriptionCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;





const container_with_bg_css = css`
  margin: 24px 0 0 0;
  &nth-child(1) {
    margin: 64px 0 0 0;
  }
`;
const title_with_bg_css = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 20px;
  }
`;

export interface FormContainerProps {
  margin?: string;
  maxWidth?: string;
}
export interface MessageNoteProps {
  color?: string;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}

const args = {
  theme: themeDefault,
  className: container_with_bg_css,
  title: 'Personal Information',
  titleClassName: title_with_bg_css,
  titleColor: '#883E89',
  titleFontSize: 28,
  showHeaderBackground: true,
  headerBackgroundColor: '#FAFAFA',
  contentMarginLeft: '0',
  contentMarginRight: '0',
  showBottomLine: false,
  bottomLineColor: '#000',
  showExtraElement: true,
};
